import { Page, Text, View, StyleSheet } from '@react-pdf/renderer';
import { disclaimerShort } from '../../lib/disclaimer';

const styles = StyleSheet.create({
  page: {
    flexDirection: 'column',
    backgroundColor: '#FFFFFF',
    padding: 40,
    minHeight: '100vh',
    position: 'relative',
  },
  landscapePage: {
    padding: 20,
  },
  content: {
    flex: 1,
    marginBottom: 80,
  },
  header: {
    fontSize: 18,
    fontWeight: 'bold',
    marginBottom: 5,
    color: '#4F5F4B',
    textAlign: 'center',
  },
  disclaimer: {
    fontSize: 8,
    color: '#757575',
    borderTopWidth: 1,
    borderTopColor: '#dfdfdf',
    borderTopStyle: 'solid',
    paddingTop: 10,
    position: 'absolute',
    bottom: 50,
    left: 40,
    right: 40,
    textAlign: 'left',
  },
  footer: {
    position: 'absolute',
    bottom: 30,
    left: 0,
    right: 0,
    textAlign: 'center',
    fontSize: 8,
    color: '#757575',
  },
});

const PDFPage = ({
  children,
  header,
  pageNumber,
  totalPages,
  showDisclaimer = true,
  showFooter = true,
  orientation = 'landscape',
  pageSize = 'A4',
}) => {
  const pageStyle = orientation === 'landscape'
    ? [styles.page, styles.landscapePage]
    : styles.page;

  return (
    <Page size={pageSize} orientation={orientation} style={pageStyle}>
      {header && (
        <Text style={styles.header}>{header}</Text>
      )}
      
      <View style={styles.content}>
        {children}
      </View>
      
      {showDisclaimer && (
        <View style={styles.disclaimer}>
          <Text>
            {disclaimerShort}
          </Text>
        </View>
      )}

      {showFooter && (
        <View style={styles.footer}>
          {/* Static "Page X of N". Page numbers are computed in ReportPDF and
              threaded in as props — NOT via @react-pdf's `fixed`+`render` page
              callback, which forces an expensive multi-pass layout that pegs the
              CPU / throws "Invalid array length" on this report's large tables. */}
          <Text>
            The Ashthorn Group
            {pageNumber ? ` - Page ${pageNumber}${totalPages ? ` of ${totalPages}` : ''}` : ''}
          </Text>
        </View>
      )}
    </Page>
  );
};

export default PDFPage;